import "./App.css";
import Wall from "./components/entrance/Wall";
import Game from "./components/game/Game";

function App() {
  return <Wall />;
}

export default App;
